"use strict";
exports["-3c9559c3"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizMrsEasTitleText","properties":{"useAutodiscover":{"type":"boolean","title":"LabelAutodiscoverGroup","default":true,"enum":[true,false],"enumNames":["LabelUseAutodiscoverRadio","LabelManuallySpecifyServerSettings"]},"userName":{"type":"string","title":"LabelMSOnlineId","maxLength":256},"password":{"type":"string","title":"LabelPassword","maxLength":256},"oAuthCredential":{"type":"object","title":"MrsOAuthCredentialsLabel"},"notice":{"type":"object","title":"PanelTitle_Notice","properties":{"testAccountConsent":{"type":"boolean","title":"TestAccountConsent","description":"NoticeDescription","oneOf":[{"const":true}]}},"required":["testAccountConsent"]},"proofOfWork":{"type":"string","title":""}},"required":["useAutodiscover","userName","password","oAuthCredential","notice","proofOfWork"],"not":{"anyOf":[{"required":["tokenStore"]},{"required":["oauthAccessToken"]},{"properties":{"authenticationType":{"const":"OAuth"}},"required":["authenticationType"]}]},"dependencies":{"useAutodiscover":{"oneOf":[{"properties":{"useAutodiscover":{"enum":[true]},"emailAddress":{"type":"string","title":"LabelEmailAddress","format":"email","maxLength":320}},"required":["emailAddress"]},{"properties":{"useAutodiscover":{"enum":[false]},"easServer":{"type":"string","title":"LabelEasServer","pattern":"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"},"emailAddress":{"type":"string","title":"LabelEmailAddress","format":"email","maxLength":320}},"required":["easServer","emailAddress"]}]}},"$id":"-3c9559c3"};
const formats0 = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
const func2 = require("ajv/dist/runtime/ucs2length").default;
const pattern0 = new RegExp("^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$", "u");

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-3c9559c3" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
const _errs2 = errors;
const _errs3 = errors;
let valid1 = false;
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.tokenStore === undefined) && (missing0 = "tokenStore")){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid1 = valid1 || _valid0;
if(!valid1){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing1;
if((data.oauthAccessToken === undefined) && (missing1 = "oauthAccessToken")){
const err1 = {};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid1 = valid1 || _valid0;
if(!valid1){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing2;
if((data.authenticationType === undefined) && (missing2 = "authenticationType")){
const err2 = {};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
else {
if(data.authenticationType !== undefined){
if("OAuth" !== data.authenticationType){
const err3 = {};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
}
var _valid0 = _errs6 === errors;
valid1 = valid1 || _valid0;
}
}
if(!valid1){
const err4 = {};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
else {
errors = _errs3;
if(vErrors !== null){
if(_errs3){
vErrors.length = _errs3;
}
else {
vErrors = null;
}
}
}
var valid0 = _errs2 === errors;
if(valid0){
const err5 = {instancePath,schemaPath:"#/not",keyword:"not",params:{},message:"must NOT be valid",schema:schema11.not,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "useAutodiscover"},message:"must have required property '"+"useAutodiscover"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.userName === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "userName"},message:"must have required property '"+"userName"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.password === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "password"},message:"must have required property '"+"password"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.oAuthCredential === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "oAuthCredential"},message:"must have required property '"+"oAuthCredential"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.notice === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "notice"},message:"must have required property '"+"notice"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.proofOfWork === undefined){
const err11 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data.useAutodiscover !== undefined){
const _errs9 = errors;
let valid4 = false;
let passing0 = null;
const _errs10 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.emailAddress === undefined){
const err12 = {instancePath,schemaPath:"#/dependencies/useAutodiscover/oneOf/0/required",keyword:"required",params:{missingProperty: "emailAddress"},message:"must have required property '"+"emailAddress"+"'",schema:schema11.dependencies.useAutodiscover.oneOf[0].required,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0],data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.useAutodiscover !== undefined){
let data1 = data.useAutodiscover;
if(!(data1 === true)){
const err13 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover.enum,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover,data:data1};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.emailAddress !== undefined){
let data2 = data.emailAddress;
if(typeof data2 === "string"){
if(func2(data2) > 320){
const err14 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/emailAddress/maxLength",keyword:"maxLength",params:{limit: 320},message:"must NOT have more than 320 characters",schema:320,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.emailAddress,data:data2};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(!(formats0.test(data2))){
const err15 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/emailAddress/format",keyword:"format",params:{format: "email"},message:"must match format \""+"email"+"\"",schema:"email",parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.emailAddress,data:data2};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/emailAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.useAutodiscover.oneOf[0].properties.emailAddress.type,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.emailAddress,data:data2};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
var _valid1 = _errs10 === errors;
if(_valid1){
valid4 = true;
passing0 = 0;
}
const _errs14 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.easServer === undefined){
const err17 = {instancePath,schemaPath:"#/dependencies/useAutodiscover/oneOf/1/required",keyword:"required",params:{missingProperty: "easServer"},message:"must have required property '"+"easServer"+"'",schema:schema11.dependencies.useAutodiscover.oneOf[1].required,parentSchema:schema11.dependencies.useAutodiscover.oneOf[1],data};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data.emailAddress === undefined){
const err18 = {instancePath,schemaPath:"#/dependencies/useAutodiscover/oneOf/1/required",keyword:"required",params:{missingProperty: "emailAddress"},message:"must have required property '"+"emailAddress"+"'",schema:schema11.dependencies.useAutodiscover.oneOf[1].required,parentSchema:schema11.dependencies.useAutodiscover.oneOf[1],data};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data.useAutodiscover !== undefined){
let data3 = data.useAutodiscover;
if(!(data3 === false)){
const err19 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/dependencies/useAutodiscover/oneOf/1/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover.enum,parentSchema:schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover,data:data3};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.easServer !== undefined){
let data4 = data.easServer;
if(typeof data4 === "string"){
if(!pattern0.test(data4)){
const err20 = {instancePath:instancePath+"/easServer",schemaPath:"#/dependencies/useAutodiscover/oneOf/1/properties/easServer/pattern",keyword:"pattern",params:{pattern: "^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"},message:"must match pattern \""+"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"+"\"",schema:"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$",parentSchema:schema11.dependencies.useAutodiscover.oneOf[1].properties.easServer,data:data4};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/easServer",schemaPath:"#/dependencies/useAutodiscover/oneOf/1/properties/easServer/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.useAutodiscover.oneOf[1].properties.easServer.type,parentSchema:schema11.dependencies.useAutodiscover.oneOf[1].properties.easServer,data:data4};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.emailAddress !== undefined){
let data5 = data.emailAddress;
if(typeof data5 === "string"){
if(func2(data5) > 320){
const err22 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/dependencies/useAutodiscover/oneOf/1/properties/emailAddress/maxLength",keyword:"maxLength",params:{limit: 320},message:"must NOT have more than 320 characters",schema:320,parentSchema:schema11.dependencies.useAutodiscover.oneOf[1].properties.emailAddress,data:data5};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(!(formats0.test(data5))){
const err23 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/dependencies/useAutodiscover/oneOf/1/properties/emailAddress/format",keyword:"format",params:{format: "email"},message:"must match format \""+"email"+"\"",schema:"email",parentSchema:schema11.dependencies.useAutodiscover.oneOf[1].properties.emailAddress,data:data5};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/dependencies/useAutodiscover/oneOf/1/properties/emailAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.useAutodiscover.oneOf[1].properties.emailAddress.type,parentSchema:schema11.dependencies.useAutodiscover.oneOf[1].properties.emailAddress,data:data5};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
var _valid1 = _errs14 === errors;
if(_valid1 && valid4){
valid4 = false;
passing0 = [passing0, 1];
}
else {
if(_valid1){
valid4 = true;
passing0 = 1;
}
}
if(!valid4){
const err25 = {instancePath,schemaPath:"#/dependencies/useAutodiscover/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.useAutodiscover.oneOf,parentSchema:schema11.dependencies.useAutodiscover,data};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
else {
errors = _errs9;
if(vErrors !== null){
if(_errs9){
vErrors.length = _errs9;
}
else {
vErrors = null;
}
}
}
}
if(data.useAutodiscover !== undefined){
let data6 = data.useAutodiscover;
if(typeof data6 !== "boolean"){
const err26 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.useAutodiscover.type,parentSchema:schema11.properties.useAutodiscover,data:data6};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(!((data6 === true) || (data6 === false))){
const err27 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.useAutodiscover.enum,parentSchema:schema11.properties.useAutodiscover,data:data6};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data.userName !== undefined){
let data7 = data.userName;
if(typeof data7 === "string"){
if(func2(data7) > 256){
const err28 = {instancePath:instancePath+"/userName",schemaPath:"#/properties/userName/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters",schema:256,parentSchema:schema11.properties.userName,data:data7};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
else {
const err29 = {instancePath:instancePath+"/userName",schemaPath:"#/properties/userName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.userName.type,parentSchema:schema11.properties.userName,data:data7};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.password !== undefined){
let data8 = data.password;
if(typeof data8 === "string"){
if(func2(data8) > 256){
const err30 = {instancePath:instancePath+"/password",schemaPath:"#/properties/password/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters",schema:256,parentSchema:schema11.properties.password,data:data8};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
else {
const err31 = {instancePath:instancePath+"/password",schemaPath:"#/properties/password/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.password.type,parentSchema:schema11.properties.password,data:data8};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data.oAuthCredential !== undefined){
let data9 = data.oAuthCredential;
if(!(data9 && typeof data9 == "object" && !Array.isArray(data9))){
const err32 = {instancePath:instancePath+"/oAuthCredential",schemaPath:"#/properties/oAuthCredential/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.oAuthCredential.type,parentSchema:schema11.properties.oAuthCredential,data:data9};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.notice !== undefined){
let data10 = data.notice;
if(data10 && typeof data10 == "object" && !Array.isArray(data10)){
if(data10.testAccountConsent === undefined){
const err33 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/required",keyword:"required",params:{missingProperty: "testAccountConsent"},message:"must have required property '"+"testAccountConsent"+"'",schema:schema11.properties.notice.required,parentSchema:schema11.properties.notice,data:data10};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data10.testAccountConsent !== undefined){
let data11 = data10.testAccountConsent;
if(typeof data11 !== "boolean"){
const err34 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.notice.properties.testAccountConsent.type,parentSchema:schema11.properties.notice.properties.testAccountConsent,data:data11};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
const _errs32 = errors;
let valid9 = false;
let passing1 = null;
const _errs33 = errors;
if(true !== data11){
const err35 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/oneOf/0/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant",schema:true,parentSchema:schema11.properties.notice.properties.testAccountConsent.oneOf[0],data:data11};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
var _valid2 = _errs33 === errors;
if(_valid2){
valid9 = true;
passing1 = 0;
}
if(!valid9){
const err36 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/oneOf",keyword:"oneOf",params:{passingSchemas: passing1},message:"must match exactly one schema in oneOf",schema:schema11.properties.notice.properties.testAccountConsent.oneOf,parentSchema:schema11.properties.notice.properties.testAccountConsent,data:data11};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
else {
errors = _errs32;
if(vErrors !== null){
if(_errs32){
vErrors.length = _errs32;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err37 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.notice.type,parentSchema:schema11.properties.notice,data:data10};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data12 = data.proofOfWork;
if(typeof data12 !== "string"){
const err38 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data12};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
}
else {
const err39 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}

exports["-7ab24ebe"] = validate11;
const schema12 = {"type":"object","properties":{"useAutodiscover":{"enum":[true]}},"$id":"-7ab24ebe"};

function validate11(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-7ab24ebe" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover !== undefined){
let data0 = data.useAutodiscover;
if(!(data0 === true)){
const err0 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema12.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.useAutodiscover.enum,parentSchema:schema12.properties.useAutodiscover,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.type,parentSchema:schema12,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate11.errors = vErrors;
return errors === 0;
}

exports["-16cb1543"] = validate12;
const schema13 = {"type":"object","properties":{"useAutodiscover":{"enum":[false]}},"$id":"-16cb1543"};

function validate12(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-16cb1543" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover !== undefined){
let data0 = data.useAutodiscover;
if(!(data0 === false)){
const err0 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema13.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema13.properties.useAutodiscover.enum,parentSchema:schema13.properties.useAutodiscover,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema13.type,parentSchema:schema13,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate12.errors = vErrors;
return errors === 0;
}

exports["-2fb2d0e5"] = validate13;
const schema14 = {"const":true,"$id":"-2fb2d0e5"};

function validate13(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-2fb2d0e5" */;
let vErrors = null;
let errors = 0;
if(true !== data){
const err0 = {instancePath,schemaPath:"#/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant",schema:true,parentSchema:schema14,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
validate13.errors = vErrors;
return errors === 0;
}
